/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React from "react";
import AllReports from "../../../MiddleMileOperations/ExceptionReports/allReports";
const BookingVolumeReports = () => {
    const embeddedId = "176169e5-5642-47e8-9f8d-099a7d2c5d55";
    const rsl = [];
    const title = "Booking Volume Reports";
    return (
        <div>
            <AllReports embeddedId={embeddedId} rsl={rsl} title={title} />
        </div>
    );
};

export default BookingVolumeReports;  
